import React from "react"

import Layout from "../../components/layout"
import Image from "../../components/image"
import SEO from "../../components/seo"

export default ({ pageContext, location }) => {
  return (
    <>
      <SEO location={location} title="Page3"/>
      <Layout pageContext={pageContext}>
        <h1>Page3</h1>
        <Image name="p3.jpg" />
      </Layout>
    </>
  );
};
